export default __webpack_public_path__ + "static/media/picture_scroll6.10856611.jpg";